"use client"
import {
  type RelativeTimeDisplay,
  type RelativeTimeOptions,
  useDateTimeFormatter,
  useRelativeTimeFormatter,
} from "@opensea/i18n"
import { Tooltip } from "@opensea/ui-kit"
import { useIsHydrated } from "@opensea/ui-kit/hooks"
import type { Nullable } from "@opensea/utils"
import { useClock } from "@opensea/wallet"

export type LiveTimestampProps = {
  date: Nullable<Date | string>
  showTooltip?: boolean
  display?: RelativeTimeDisplay
  units?: {
    hours?: boolean
    minutes?: boolean
    seconds?: boolean
  }
} & Omit<RelativeTimeOptions, "display" | "units">

export function LiveTimestamp({
  date,
  display = "compact-contextual",
  units,
  showTooltip = true,
  ...rest
}: LiveTimestampProps) {
  const now = useClock()
  const relativeFormat = useRelativeTimeFormatter()
  const dateFormat = useDateTimeFormatter()
  const dateToUse = typeof date === "string" ? new Date(date) : date

  const isHydrated = useIsHydrated()

  if (!isHydrated) {
    return ""
  }

  return (
    <Tooltip
      content={dateFormat(dateToUse, {
        display: "datetime",
      })}
      disabled={!(showTooltip && dateToUse)}
    >
      <span>
        {relativeFormat(dateToUse, {
          now,
          display,
          units,
          ...rest,
        })}
      </span>
    </Tooltip>
  )
}
